const normalizeCode = (string) => {
  const DecomposedString = string.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Removes accents and diacretics from the string
  const normalizedString = DecomposedString.toLowerCase().replace(/[^A-Za-z_]/g, '');
  return normalizedString;
};

export { normalizeCode };
